var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    _vm._b(
      {
        attrs: {
          height: _vm.size || 32,
          width: _vm.size || 32,
          viewBox: "0 0 24 24",
        },
      },
      "svg",
      _vm.$attrs,
      false
    ),
    [
      _c("path", {
        attrs: {
          d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m-2 15l-5-5l1.41-1.41L10 14.17l7.59-7.59L19 8z",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }